if (!customElements.get('furever-sticky-atc')) {
  customElements.define(
    'furever-sticky-atc',
    class FureverStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = document.getElementById(`ProductInfo-${this.sectionId}`);
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.variantInput = this.querySelector('input[name="id"]');
        this.quantityInput = this.querySelector('[data-sticky-quantity]');
        this.submitButton = this.querySelector('button[name="add"]');
        this.price = this.querySelector('[data-sticky-price]');

        if (!this.productInfo || !this.mainButton || !this.variantInput || !this.submitButton) return;

        this.onScroll = this.updateVisibility.bind(this);
        this.onMainChange = () => window.requestAnimationFrame(() => this.syncFromMain());
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.productInfo.addEventListener('change', this.onMainChange);
        this.productInfo.addEventListener('input', this.onMainChange);

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.sectionId) return;
            this.syncVariant(data.variant, data.html);
          });
        } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.sectionId) return;
            this.syncVariant(data.variant, data.html);
          });
        }

        this.syncFromMain();
        this.updateVisibility();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.productInfo?.removeEventListener('change', this.onMainChange);
        this.productInfo?.removeEventListener('input', this.onMainChange);
        this.unsubscribeVariant?.();
      }

      syncVariant(variant, html) {
        if (variant?.id) {
          this.variantInput.value = variant.id;
          this.variantInput.disabled = !variant.available;
          this.submitButton.disabled = !variant.available;
        } else {
          this.variantInput.value = '';
          this.variantInput.disabled = true;
          this.submitButton.disabled = true;
        }

        const sourceButton = html?.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const sourcePrice = html?.getElementById(`price-${this.sectionId}`);
        if (sourceButton) this.submitButton.querySelector('span').textContent = sourceButton.textContent.trim();
        if (sourcePrice) this.updatePrice(sourcePrice);
        this.syncQuantity();
      }

      syncFromMain() {
        const mainVariant = this.productInfo.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
        if (mainVariant) {
          this.variantInput.value = mainVariant.value;
          this.variantInput.disabled = mainVariant.disabled;
        }

        this.submitButton.disabled = this.mainButton.disabled;
        this.submitButton.querySelector('span').textContent = this.mainButton.querySelector('span')?.textContent.trim() || this.mainButton.textContent.trim();

        const sourcePrice = this.productInfo.querySelector(`#price-${this.sectionId}`);
        if (sourcePrice) this.updatePrice(sourcePrice);
        this.syncQuantity();
      }

      updatePrice(sourcePrice) {
        const priceRoot = sourcePrice.querySelector('.price');
        const priceItem = priceRoot?.classList.contains('price--on-sale')
          ? sourcePrice.querySelector('.price__sale .price-item--last')
          : sourcePrice.querySelector('.price__regular .price-item--regular');
        if (priceItem) this.price.textContent = priceItem.textContent.replace(/\s+/g, ' ').trim();
      }

      syncQuantity() {
        const mainQuantity = this.productInfo.querySelector(`#Quantity-${this.sectionId}`);
        if (mainQuantity && this.quantityInput) this.quantityInput.value = mainQuantity.value;
      }

      updateVisibility() {
        const shouldShow = window.innerWidth < 750 && this.mainButton.getBoundingClientRect().bottom < 84;
        this.toggleAttribute('data-visible', shouldShow);
        this.toggleAttribute('inert', !shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
    }
  );
}
